export default __webpack_public_path__ + "static/media/password_key.96ce538f.svg";